import React, { useState, Fragment, useEffect } from "react";
import { Container, Form, Col, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_UTM_DATA, getSessionStorageItem } from '../../../../../sessionStorage'
import { RadioInput } from "../../../../Helpers/Inputs";
import BackNext from '../../../Common/SubComponents/BackNext';
import * as Constants from '../../../../Helpers/Constants/States';
import IsJuvenile from '../../../../Helpers/Dates/IsJuvenile';
import Age from '../../../../Helpers/Dates/Age'
import { customValidators } from '../../../../Helpers/Validators/customValidators'
export default function MedicalHistory(props) {
  var currentAge = Age(props.formStateForUnderwriting.pages.basicInfo.birthdate)
  var currentBirthdate = props.formStateForUnderwriting.pages.basicInfo.birthdate

  const { register, errors, handleSubmit, setValue } = useForm({
    validationSchema: MedicalHistory.ValidationSchema(currentAge, currentBirthdate),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const [loading, setLoading] = useState(false)

  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
  const sessionId = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId;

  const drivingState = props.formStateForUnderwriting && props.formStateForUnderwriting.pages && props.formStateForUnderwriting.pages.basicInfo && props.formStateForUnderwriting.pages.basicInfo.state;
  const isJuvenile = IsJuvenile(props.formStateForUnderwriting && props.formStateForUnderwriting.pages && props.formStateForUnderwriting.pages.basicInfo && props.formStateForUnderwriting.pages.basicInfo.birthdate);

  useEffect(() => {
    register({ name: 'isJuvenile' });
    setValue('isJuvenile', isJuvenile);
  }, [register])

  const getTotalInches = (height) => {
    const radix = 10;
    let totalInches = 0;
    if (height) {
      var heightSplit = height.replace("in", "").split("ft");
      const feet = heightSplit[0].trim();
      const inches = heightSplit[1].trim();
      totalInches = (parseInt(feet, radix) * 12) + parseInt(inches, radix);
    }
    return totalInches;
  }

  const getWeight = (weight) => {
    let totalWeight = 0;
    if (weight) {
      var wt = weight.replace("pounds", "").trim();
      totalWeight = wt;
    }
    return totalWeight;
  }

  const getUnderwriting = () => {
    setLoading(true);
    const pages = props.formStateForUnderwriting.pages;
    const formStateObj = {
      firstName: isJuvenile === false ? pages.insuredInfo.firstName : pages.insuredInfo.childFirstName,
      lastName: isJuvenile === false ? pages.insuredInfo.lastName : pages.insuredInfo.childLastName,
      ssn: isJuvenile === false ? pages.insuredInfo.socialSecurityNumber : pages.insuredInfo.childSocialSecurityNumber,
      address1: pages.insuredInfo.streetAddress,
      address2: pages.insuredInfo.apartment,
      city: pages.insuredInfo.city,
      state: pages.insuredInfo.state,
      zip: pages.insuredInfo.zip,
      phone: pages.insuredInfo.phone,
      email: pages.insuredInfo.email,
      birthdate: pages.basicInfo.birthdate,
      isJuv: isJuvenile,
      totalInches: getTotalInches(pages.basicInfo.height),
      weight: getWeight(pages.basicInfo.weight),
      gender: pages.basicInfo.gender,
      activeOccupation: props.formState.activeOccupation,
      tobaccoUse: pages.basicInfo.tobacco,
      felony: props.formState.felony,
      inForcePolicy: props.formState.inForceInsurance,
      replacement: props.formState.replacement,
      aids: props.formState.aids,
      hasSeriousDisease: isJuvenile === true ? props.formState.juniorSeriousDisease : props.formState.seriousDisease,
      hasMentalDisease: isJuvenile === true ? props.formState.juniorMentalDisease : props.formState.mentalDisease,
      under12Months: props.formState.under12Months,
      premature: props.formState.premature,
      recentlyHospitalized: isJuvenile === true ? props.formState.juniorHospitalized : props.formState.hospitalized,
      juvenile13orOver: props.formState.junior13orOver,
      juvenileTobaccoOrDrugs: props.formState.juniorTobaccoOrDrugs,
      naturalBorn: true,
      drivingState: pages.basicInfo.state,
      driversLicenseState: pages.insuredInfo.driversLicenseState,
      replacementUseExistingPolicyFunds: props.formState.replacementUseExistingPolicyFunds,
      replacementTerminateExistingPolicy: props.formState.replacementTerminateExistingPolicy,
      ownerFirstName: isJuvenile === true ? pages.insuredInfo.firstName : '',
      ownerLastName: isJuvenile === true ? pages.insuredInfo.lastName : '',
      ownerSsn: isJuvenile === true ? pages.insuredInfo.socialSecurityNumber : '',
      ownerAddress1: isJuvenile === true ? pages.insuredInfo.streetAddress : '',
      ownerAddress2: isJuvenile === true ? pages.insuredInfo.apartment : '',
      ownerCity: isJuvenile === true ? pages.insuredInfo.city : '',
      ownerState: isJuvenile === true ? pages.insuredInfo.state : '',
      ownerZip: isJuvenile === true ? pages.insuredInfo.zip : '',
      ownerBirthdate: isJuvenile === true ? pages.insuredInfo.ownerBirthdate : '',
      consumerApplicationId: props.formStateForUnderwriting.consumerApplicationId,
      oneClickAccountId: props.formStateForUnderwriting.oneClickAccountId,
      sessionId: sessionId,
    }
    formStateObj.UTMs = getSessionStorageItem(SESSION_STORAGE_UTM_DATA) || "";
    fetch(
      `${covrServicesUrl}/api/minnspwl/Underwriting`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': sessionId
      },
      body: JSON.stringify(formStateObj)
    }
    )
      .then((res) => res.json())
      .then((data) => {
        if (JSON.parse(data).Status === 0) { //eligible
          props.onNext();
        }
        else {
          props.ineligible();
        }
      })
      .catch((error) => {
        setLoading(false)
      });
  }

  const getLabelForAids = () => {
    if (drivingState === Constants.CALIFORNIA) {
      return "Have you ever received medication for or been diagnosed by a medical professional as having Acquired Immune Deficiency Syndrome (AIDS) or AIDS Related Complex (ARC)?";
    } else if (drivingState === Constants.FLORIDA) {
      return "Have you ever tested positive for exposure to the HIV infection or been diagnosed as having ARC or AIDS caused by the HIV infection or other sickness or condition derived from such infection?";
    } else {
      return "Have you ever received medication for, been diagnosed by a medical professional, or tested positive for: Human Immunodeficiency Virus (HIV), Acquired Immune Deficiency Syndrome (AIDS) or AIDS Related Complex (ARC)?";
    }
  }

  const getLabelForSeriousDisease = () => {
    return (drivingState === Constants.FLORIDA
      ? "Have you ever received medication, or been diagnosed by a licensed member of the medical professional for any of the following: heart disorder, cancer (excluding basal cell skin cancer), stroke, kidney disorder, liver disorder or hepatitis (excluding Type A), lung disorder (excluding asthma and bronchitis), alcoholism or substance abuse, or diabetes?"
      : "Have you ever received medication for, been diagnosed by a medical professional, or tested positive for any of the following: heart disorder, cancer (excluding basal cell skin cancer), stroke, kidney disorder, liver disorder or hepatitis (excluding Type A), lung disorder (excluding asthma and bronchitis), alcoholism or substance abuse, or diabetes?"
    );
  }

  const getLabelForMentalDisease = () => {
    return (drivingState === Constants.FLORIDA
      ? "In the past five years, have you been treated by a licensed member of the medical profession for schizophrenia, suicide attempt, or bipolar disorder?"
      : "In the past five years, have you been treated by a member of the medical profession for schizophrenia, suicide attempt, or bipolar disorder?"
    );
  }

  const getLabelForPremature = () => {
    switch (drivingState) {
      case Constants.CALIFORNIA:
      case Constants.CONNECTICUT:
      case Constants.DISTRICT_OF_COLUMBIA:
      case Constants.NORTH_DAKOTA:
        return "Was this child born prematurely (less than 28 weeks of gestation) or with any abnormalities?";
      case Constants.FLORIDA:
        return "Was this child born prematurely (less than 28 weeks of gestation) or with any abnormalities, disorder or disease requiring diagnosis or treatment by a licensed member of the medical profession, consulted by the applicant?";
      default:
        return "Was this child born prematurely (less than 28 weeks of gestation) or with any disorder or disease requiring treatment by a member of the medical profession?";
    }
  }

  const getLabelForJuniorSeriousDisease = () => {
    switch (drivingState) {
      case Constants.CALIFORNIA:
      case Constants.CONNECTICUT:
      case Constants.DISTRICT_OF_COLUMBIA:
      case Constants.NORTH_DAKOTA:
        return "Within the past 12 months, has this child had a seizure or been treated in the ER for, or hospitalized for a respiratory disorder (excluding the common cold)?";
      case Constants.FLORIDA:
        return "Within the past 12 months, has this child been diagnosed or treated by a licensed member of the medical profession, consulted by the applicant, for a seizure or been treated in the ER for, or hospitalized for a respiratory disorder (excluding the common cold)?";
      default:
        return "Within the past 12 months, has the child been diagnosed, treated, tested positive for or been given medical advice by a member of the medical profession for seizure or been treated in the ER for, or hospitalized for a respiratory disorder(excluding the common cold)?";
    }
  }

  const getLabelForJuniorMentalDisease = () => {
    return drivingState === Constants.FLORIDA ?
      "Within the past 5 years, has the child been treated or diagnosed by a licensed member of the medical profession for heart disease or disorder, any form of cancer, diabetes, or any mental health disorder or condition including Depression, Autism or Aspergers?" :
      "Within the past 5 years, has the child been treated or diagnosed by a medical professional for heart disease or disorder, any form of cancer, diabetes, or any mental health disorder or condition including Depression, Autism, Aspergers, etc?";
  }

  return (
    <Container>
      <Row className="justify-content-center formPage">

        <Col lg={5}>

          <div className="formPageTitle">Medical History</div>

          <form className="quote-form" onSubmit={handleSubmit(getUnderwriting)}>
            {isJuvenile === false ? (
              <Fragment>
                <Form.Group>
                  <RadioInput
                    name="activeOccupation"
                    id="activeOccupation"
                    label="Are you actively performing all the duties of your regular occupation (including homemaker or student)?"
                    value={props.formState.activeOccupation}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('activeOccupation', e.target.value)}
                    errors={errors.activeOccupation}
                    inputRef={register}
                  />
                </Form.Group>

                <Form.Group>
                  <RadioInput
                    name="felony"
                    id="felony"
                    label="Have you ever been convicted of a felony, DUI, had your driver's license suspended or revoked, or are you currently on probation or parole?"
                    value={props.formState.felony}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('felony', e.target.value)}
                    errors={errors.felony}
                    inputRef={register}
                  />
                </Form.Group>

                <Form.Group>
                  <RadioInput
                    name="inForceInsurance"
                    id="inForceInsurance"
                    label="Do you have any life insurance or annuity in force?"
                    value={props.formState.inForceInsurance}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('inForceInsurance', e.target.value)}
                    errors={errors.inForceInsurance}
                    inputRef={register}
                  />
                </Form.Group>

                <Form.Group>
                  <RadioInput
                    name="replacement"
                    id="replacement"
                    label="Do you intend for this policy to replace any annuity or life insurance policy you currently have with another company?"
                    value={props.formState.replacement}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('replacement', e.target.value)}
                    errors={errors.replacement}
                    inputRef={register}
                  />
                </Form.Group>

                <Form.Group>
                  <RadioInput
                    name="aids"
                    id="aids"
                    label={getLabelForAids()}
                    value={props.formState.aids}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('aids', e.target.value)}
                    errors={errors.aids}
                    inputRef={register}
                  />
                </Form.Group>

                {/* <Form.Group>
            <RadioInput
              name="aidsBloodTest"
              id="aidsBloodTest"
              label="Have you ever had a blood test showing evidence of antibodies to the AIDS (HIV) virus for the purpose of obtaining insurance?"
              value={props.formState.aidsBloodTest}
              radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
              onChange={e => props.onFieldChange('aidsBloodTest', e.target.value)}
              errors={errors.aidsBloodTest}
              inputRef={register}
            />
          </Form.Group> */}

                <Form.Group>
                  <RadioInput
                    name="seriousDisease"
                    id="seriousDisease"
                    label={getLabelForSeriousDisease()}
                    value={props.formState.seriousDisease}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('seriousDisease', e.target.value)}
                    errors={errors.seriousDisease}
                    inputRef={register}
                  />
                </Form.Group>

                <Form.Group>
                  <RadioInput
                    name="mentalDisease"
                    id="mentalDisease"
                    label={getLabelForMentalDisease()}
                    value={props.formState.mentalDisease}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('mentalDisease', e.target.value)}
                    errors={errors.mentalDisease}
                    inputRef={register}
                  />
                </Form.Group>

                <Form.Group>
                  <RadioInput
                    name="hospitalized"
                    id="hospitalized"
                    label="In the past 90 days, have you been hospitalized for more than two days for any reason (excluding maternity)?"
                    value={props.formState.hospitalized}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('hospitalized', e.target.value)}
                    errors={errors.hospitalized}
                    inputRef={register}
                  />
                </Form.Group>
              </Fragment>
            )
              : (
                <Fragment>
                  <Form.Group>
                    <RadioInput
                      name="under12Months"
                      id="under12Months"
                      label="Is the child presently under 12 months of age?"
                      value={props.formState.under12Months}
                      radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                      onChange={e => props.onFieldChange('under12Months', e.target.value)}
                      errors={errors.under12Months}
                      inputRef={register}
                    />
                  </Form.Group>

                  {props.formState.under12Months === "true" && (
                    <Form.Group>
                      <RadioInput
                        name="premature"
                        id="premature"
                        label={getLabelForPremature()}
                        value={props.formState.premature}
                        radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                        onChange={e => props.onFieldChange('premature', e.target.value)}
                        errors={errors.premature}
                        inputRef={register}
                      />
                    </Form.Group>
                  )}

                  <Form.Group>
                    <RadioInput
                      name="juniorSeriousDisease"
                      id="juniorSeriousDisease"
                      label={getLabelForJuniorSeriousDisease()}
                      value={props.formState.juniorSeriousDisease}
                      radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                      onChange={e => props.onFieldChange('juniorSeriousDisease', e.target.value)}
                      errors={errors.juniorSeriousDisease}
                      inputRef={register}
                    />
                  </Form.Group>

                  <Form.Group>
                    <RadioInput
                      name="juniorMentalDisease"
                      id="juniorMentalDisease"
                      label={getLabelForJuniorMentalDisease()}
                      value={props.formState.juniorMentalDisease}
                      radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                      onChange={e => props.onFieldChange('juniorMentalDisease', e.target.value)}
                      errors={errors.juniorMentalDisease}
                      inputRef={register}
                    />
                  </Form.Group>

                  <Form.Group>
                    <RadioInput
                      name="juniorHospitalized"
                      id="juniorHospitalized"
                      label="In the past 90 days, has the child been hospitalized for one or more days?"
                      value={props.formState.juniorHospitalized}
                      radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                      onChange={e => props.onFieldChange('juniorHospitalized', e.target.value)}
                      errors={errors.juniorHospitalized}
                      inputRef={register}
                    />
                  </Form.Group>

                  <Form.Group>
                    <RadioInput
                      name="junior13orOver"
                      id="junior13orOver"
                      label="Is the child presently 13 years of age or older?"
                      value={props.formState.junior13orOver}
                      radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                      onChange={e => props.onFieldChange('junior13orOver', e.target.value)}
                      errors={errors.junior13orOver}
                      inputRef={register}
                    />
                  </Form.Group>

                  {props.formState.junior13orOver === "true" && (
                    <Form.Group>
                      <RadioInput
                        name="juniorTobaccoOrDrugs"
                        id="juniorTobaccoOrDrugs"
                        label="Has this child used any tobacco or non-prescribed drug or chemical (other than over the counter medicine under the direction of a parent or legal guardian)?"
                        value={props.formState.juniorTobaccoOrDrugs}
                        radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                        onChange={e => props.onFieldChange('juniorTobaccoOrDrugs', e.target.value)}
                        errors={errors.juniorTobaccoOrDrugs}
                        inputRef={register}
                      />
                    </Form.Group>
                  )}

                  <Form.Group>
                    <RadioInput
                      name="juniorInForceInsurance"
                      id="juniorInForceInsurance"
                      label="Does the child have any life insurance or annuity in force?"
                      value={props.formState.juniorInForceInsurance}
                      radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                      onChange={e => props.onFieldChange('juniorInForceInsurance', e.target.value)}
                      errors={errors.juniorInForceInsurance}
                      inputRef={register}
                    />
                  </Form.Group>

                  <Form.Group>
                    <RadioInput
                      name="juniorReplacement"
                      id="juniorReplacement"
                      label="Do you intend for this policy to replace any annuity or life insurance policy you currently have with any company?"
                      value={props.formState.juniorReplacement}
                      radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                      onChange={e => props.onFieldChange('juniorReplacement', e.target.value)}
                      errors={errors.juniorReplacement}
                      inputRef={register}
                    />
                  </Form.Group>

                </Fragment>
              )}
            {props.formState.inForceInsurance === "true" || props.formState.juniorInForceInsurance === "true" ?
              <div>
                <Form.Group>
                  <RadioInput
                    name="replacementUseExistingPolicyFunds"
                    id="replacementUseExistingPolicyFunds"
                    label="Are you considering discontinuing making premium payments, surrendering, forfeiting, assigning to the insurer, or otherwise terminating your existing policy or contract?"
                    value={props.formState.replacementUseExistingPolicyFunds}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('replacementUseExistingPolicyFunds', e.target.value)}
                    errors={errors.replacementUseExistingPolicyFunds}
                    inputRef={register}
                  />
                </Form.Group>

                <Form.Group>
                  <RadioInput
                    name="replacementTerminateExistingPolicy"
                    id="replacementTerminateExistingPolicy"
                    label="Are you considering using funds from your existing policies or contracts to pay premiums due on the new policy or contract?"
                    value={props.formState.replacementTerminateExistingPolicy}
                    radios={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => props.onFieldChange('replacementTerminateExistingPolicy', e.target.value)}
                    errors={errors.replacementTerminateExistingPolicy}
                    inputRef={register}
                  />
                </Form.Group>
              </div>
              : ""}
            <BackNext onBack={props.onBack} disabled={loading} />
          </form>
        </Col>
      </Row>
    </Container>
  )
}

MedicalHistory.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
}

MedicalHistory.ValidationSchema = (currentAge, currentBirthdate) => {
  return object().shape({
    activeOccupation: string().when('isJuvenile', {
      is: false,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    felony: string().when('isJuvenile', {
      is: false,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    inForceInsurance: string().when('isJuvenile', {
      is: false,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    replacement: string().when('isJuvenile', {
      is: false,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    aids: string().when('isJuvenile', {
      is: false,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    seriousDisease: string().when('isJuvenile', {
      is: false,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    mentalDisease: string().when('isJuvenile', {
      is: false,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    hospitalized: string().when('isJuvenile', {
      is: false,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    under12Months: string().when('isJuvenile', {
      is: true,
      then: customValidators.string().
        isUnder12Months('This field is required.', currentBirthdate)
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    premature: string().when('under12Months', {
      is: "true",
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    juniorSeriousDisease: string().when('isJuvenile', {
      is: true,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    juniorMentalDisease: string().when('isJuvenile', {
      is: true,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    juniorHospitalized: string().when('isJuvenile', {
      is: true,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    junior13orOver: string().when('isJuvenile', {
      is: true,
      then: customValidators.string().
        isJuniorAge13orOver('This field is required.', currentAge)
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    juniorTobaccoOrDrugs: string().when('junior13orOver', {
      is: "true",
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    juniorInForceInsurance: string().when('isJuvenile', {
      is: true,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    juniorReplacement: string().when('isJuvenile', {
      is: true,
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    replacementUseExistingPolicyFunds: string().when(['inForceInsurance', 'juniorInForceInsurance'], {
      is: (inForceInsurance, juniorInForceInsurance) => inForceInsurance === "true" || juniorInForceInsurance === "true",
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    replacementTerminateExistingPolicy: string().when(['inForceInsurance', 'juniorInForceInsurance'], {
      is: (inForceInsurance, juniorInForceInsurance) => inForceInsurance === "true" || juniorInForceInsurance === "true",
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
  })
};

MedicalHistory.DefaultFormState = (prefill = false) => {
  return {
    activeOccupation: prefill ? "true" : "",
    felony: prefill ? "false" : "",
    inForceInsurance: prefill ? "false" : "",
    replacement: prefill ? "false" : "",
    aids: prefill ? "false" : "",
    seriousDisease: prefill ? "false" : "",
    mentalDisease: prefill ? "false" : "",
    hospitalized: prefill ? "false" : "",
    under12Months: prefill ? "false" : "",
    premature: prefill ? "false" : "",
    juniorSeriousDisease: prefill ? "false" : "",
    juniorMentalDisease: prefill ? "false" : "",
    juniorHospitalized: prefill ? "false" : "",
    junior13orOver: prefill ? "false" : "",
    juniorTobaccoOrDrugs: prefill ? "false" : "",
    juniorInForceInsurance: prefill ? "false" : "",
    juniorReplacement: prefill ? "false" : "",
    replacementUseExistingPolicyFunds: "",
    replacementTerminateExistingPolicy: "",
  }
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Securian/WL/steps/MedicalHistory.js